// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"155":"7d598f2d","340":"6f3747bc","393":"5c51c633","405":"956189f2","463":"cd75100b","680":"5a78935a","860":"bdfbe1c6","866":"59799e3b","881":"437b1fbd","920":"1a8f6ec9"}[chunkId] + ".js";
};